import React from 'react';
import { connect } from 'react-redux';

import { selectIsUserStandard, selectIsUserAdvanced, selectIsUserProfessional } from '../../redux/auth/user/selectors';

import CheckoutButtonStandard from './CheckoutButtonStandard';

const CheckoutButtonStandardConnected = (props) => <CheckoutButtonStandard {...props} />;

const mapStateToProps = (state) => ({
  isUserAdvanced: selectIsUserAdvanced(state),
  isUserProfessional: selectIsUserProfessional(state),
  isUserStandard: selectIsUserStandard(state),
});

export default connect(mapStateToProps)(CheckoutButtonStandardConnected);
